"use client";

import React, { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
type Metric = {
  id: string;
  value: number;
  prefix?: string;
  suffix?: string;
  label: string;
  className: string;
  gradient: string;
  delayClass: string;
};
const metrics: Metric[] = [];
function AnimatedNumber({
  value
}: {
  value: number;
}) {
  const [count, setCount] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    if (isVisible) {
      let start = 0;
      const duration = 2000;
      const fps = 60;
      const increment = value / (duration / (1000 / fps));
      const timer = setInterval(() => {
        start += increment;
        if (start >= value) {
          setCount(value);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 1000 / fps);
      return () => clearInterval(timer);
    }
  }, [isVisible, value]);
  return <span ref={ref} className="!w-[89px]">{count}</span>;
}
export default function CareerImpactInNumbers() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return;
}